import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext.jsx";
import { useT } from "../../i18n/LanguageContext.jsx";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const { t } = useT();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="max-w-[1400px] mx-auto px-6 py-12" data-testid="auth-loading">
        <div className="data-label">{t("auth.checking")}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
